import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { ImageField, LinkField, StringField, THeadingTag } from '../../../types/types';
import { HeroBannerFields, HeroBannerParams, HeroBannerProps } from '../types/heroBanner.types';

export class HeroBannerModel {
  private readonly fields?: HeroBannerFields;
  private readonly rendering?: ComponentRendering;
  private readonly params?: HeroBannerParams;

  constructor(props: HeroBannerProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
    this.params = props?.params;
  }

  get description(): StringField | undefined {
    return this.fields?.description;
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get mobileImage(): ImageField | undefined {
    return this.fields?.mobileImage;
  }

  get primaryLink(): LinkField | undefined {
    return this.fields?.link1;
  }

  get secondaryLink(): LinkField | undefined {
    return this.fields?.link2;
  }

  get isPrimaryLinkExist(): boolean {
    return !!(this.primaryLink?.value?.href && this.primaryLink?.value?.text);
  }

  get validSecondaryLinkExists(): boolean {
    return !!(this?.secondaryLink?.value?.href && this?.secondaryLink?.value?.text);
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get textColor(): StringField | undefined {
    return this.fields?.['textColor']?.fields?.Key;
  }

  get downloadButtonLink(): LinkField | undefined {
    return this?.fields?.downloadButtonLink;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h1';
  }

  get dataSource(): string | undefined {
    return this.rendering?.dataSource;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
  
  get isGradientDisabled(): boolean | undefined {
    return this.params?.disableGradient === '1';
  }
}
